<script>
import generalData from "@/utils/training-data/short_video_data.json";
export default {
    data() {
        return {
            tableData: generalData.liveData,
            dayList: ["7天","15天","30天"],
            active: 0,
            value1: "",
            panelListData: [
                {count: "8", desc: "直播场次", tip: null},
                {count: "10.5W", desc: "累计观众数", tip: null},
                {count: "2分43秒", desc: "直播人均观看时长", tip: "直播间观看时长/进入直播间用户数"},
                {count: "2", desc: "直播进入私信次数", tip: "从直播间通过私信工具进入私信会话入口的次数"},
                {count: "1", desc: "直播线索量", tip: "直播间内获得的线索次数，不包含引导私信的线索量"},
            ],
            tableKey: 0,
        }
    },
    methods: {
        changeDay(key) {
            this.tableKey++;
            this.active = key;
            if (this.active === 0) {
                this.tableData = generalData.liveData.slice(0, 7)
            }
            if (this.active === 1) {
                this.tableData = generalData.liveData.slice(15)
            }
            if (this.active === 2) {
                this.tableData = generalData.liveData
            }
        }
    },
    mounted() {
        this.tableData = this.tableData.slice(0, 7);
    }
}

</script>

<template>
    <div class="live-data-container">
        <el-scrollbar style="height:100%">
            <div class="live-history-container">
                <div class="live-header" style="display: flex; align-items: center;justify-content: flex-start;margin-bottom: 24px;">
                    <div style="font-weight: 600;color: #333;margin-right: 5px;">
                        历史直播数据汇总
                    </div>
                    <el-tooltip effect="dark" placement="top" content="可查看最近有数一天及历史的直播数据">
                        &nbsp;<i style="color: #C4C4C4;" class="el-icon-question"></i></el-tooltip>
                </div>
                <div class="live-options flex-start-center">
                    <div class="label">展示时间</div>
                    <div class="nav-item" v-for="(item, key) in dayList"
                         :key="key"
                         :class="active === key ? 'active' : ''"
                         @click="changeDay(key)"
                    >
                        {{item}}
                    </div>
                    <el-date-picker
                        style="margin-right: 8px;"
                        v-model="value1"
                        :disabled="true"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <div class="desc">
                        仅支持查询近30天的数据
                    </div>
                </div>
                <div class="live-data-panel flex-start-center">
                    <div class="panel-item" v-for="(item, key) in panelListData">
                        <div class="count-txt">
                            {{ item.count }}
                        </div>
                        <div class="count-desc">
                            <span class="desc">{{ item.desc }}</span>
                            <el-tooltip effect="dark" placement="top" :content="item.tip" v-if="item.tip">
                                &nbsp;<i style="color: #C4C4C4;" class="el-icon-question"></i></el-tooltip>
                        </div>
                    </div>
                </div>
            </div>
            <div class="live-data-table">
                <el-table :data="tableData" :key="tableKey" header-cell-class-name="custom-header">
                    <el-table-column label="直播记录ID" prop="liveRecordId" ></el-table-column>
                    <el-table-column label="日期" prop="date" ></el-table-column>
                    <el-table-column label="直播时长" prop="duration" ></el-table-column>
                    <el-table-column label="累计观众数" prop="totalViewers" ></el-table-column>
                    <el-table-column >
                        <template slot="header" slot-scope="scope">
                            <span>直播人均观看时长</span>
                            <el-tooltip effect="dark" placement="top" content="直播间观看时长/进入直播间用户数">
                                &nbsp;<i style="margin-left: 4px;color: #C4C4C4;" class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.avgWatchTime}}
                        </template>
                    </el-table-column>
                    <el-table-column >
                        <template slot="header" slot-scope="scope">
                            <span>直播线索量</span>
                            <el-tooltip effect="dark" placement="top" content="直播间内获得的线索次数，不包含引导私信的线索量">
                                &nbsp;&nbsp;<i style="margin-left: 4px;color: #C4C4C4;" class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.clueCount}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary">查看详情</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-scrollbar>
    </div>
</template>

<style scoped lang="scss">
.flex-start-center {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.live-data-container {
    &:deep(.el-scrollbar) {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
    &, & * {
        box-sizing: border-box;
    }
    width: 100%;
    height: 100%;
    .live-history-container {
        width: 100%;
        padding: 32px;
        background: #FFF;
        margin: 16px 0;
        border-radius: 12px;
    }
    .live-data-panel {
        margin-top: 16px;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        padding: 24px;
        .panel-item {
            &:first-child {
                padding-left: 0;
            }
            padding: 0 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            border-right-width: 1px;
            border-right-color: #f0f0f0;
            border-right-style: solid;
            &:last-child {
                border: none;
            }
            .count-txt {
                font-size: 30px;
                line-height: 45px;
                font-weight: 700;
                .desc {
                    margin-right: 8px;
                }
            }
        }
    }
    .live-options {
        color: #333;
        font-size: 14px;
        .nav-item {
            cursor: pointer;
            width: 88px;
            height: 32px;
            text-align: center;
            border-radius: 4px;
            border: 1px solid #16182329;
            margin: 0 8px;
            line-height: 32px;
            &.active {
                color: #2a55e5;
                border-color: #2a55e5;
            }
        }
    }
    .live-data-table {
        &:deep(.el-table) {
            .custom-header {
                background: #f5f7fa;
                color: #161823;
            }
        }
        background: #fff;
        width: 100%;
        margin: 16px 0;
        border-radius: 12px;
        padding: 32px;
    }
}

</style>
